import { useEffect, useState } from "react";
import Comment from "./Comment";
import AddComment from "./AddComment";
import cookies from "js-cookie";
import axios from "axios";
import { link } from "../../../config";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Rates({ product, getProduct }) {
  const [showMore, setShowMore] = useState(false);
  const [commentContent, setCommentContent] = useState("");
  const token = cookies.get("user");
  const { id } = useParams();
  const [rates, setRates] = useState([]);
  const {t} = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post(
        `${link}customer-reviews`,
        {
          productId: id,
          content: commentContent,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setCommentContent("");
    } catch (error) {
      console.log(error);
    }
  };

  const getReviews = async () => {
    try {
      const { data } = await axios.get(
        `${link}customer-reviews/product/${id}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setRates(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReviews();
  }, []);
  return (
    <section className="people-rating mt-2 pt-5">
      {rates.filter((rate) => rate.show).length > 0 && <h2>{t("reviews")}</h2>}

      {/* {showMore ? (
        <>
          {product?.rates?.map((item, index) => (
            <div key={index}>
              <Comment rating={item.rate} rate={item} />
            </div>
          ))}
        </>
      ) : (
        <>
          {product?.rates?.map((item, index) => {
            if (index < 4) {
              return (
                <div key={index}>
                  <Comment rating={item.rate} rate={item} />
                </div>
              );
            }
          })}
        </>
      )} */}
      {/* <p className="for-more" onClick={() => setShowMore(true)}>
        شاهد جميع التقييمات
      </p> */}

      {rates.filter((rate) => rate.show).length > 0 && (
        <div style={{ height: "400px", overflowY: "auto" }}>
          {rates
            .filter((rate) => rate.show)
            .map((item, index) => (
              <div key={index}>
                <div className="comment d-flex align-items-start gap-2 border-top border-bottom m-0 pt-4 pb-3">
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      backgroundColor: "#164C96",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: "14px",
                    }}
                  >
                    {item?.userId?.username?.charAt(0).toUpperCase()}
                  </div>
                  <div className="comment-content flex-grow-1">
                    <div className="comment-owner d-flex justify-content-between flex-grow-1 w-100 ">
                      <div className="d-flex">
                        <h3>{item?.userId?.username}</h3>
                        <div
                          className="rate d-flex align-items-center gap-1 mx-2 "
                          style={{ width: "fit-content" }}
                        >
                          {/* Star rating display */}
                          {Array.from({ length: 5 }, (_, i) => (
                            <svg
                              key={i}
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill={i < item.rate ? "#FFD700" : "#D3D3D3"} // Gold for filled, gray for empty
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>

                    <p>{item?.content}</p>

                    {/* Display comments */}
                    {item.comments && item.comments.length > 0 && (
                      <div className="comments-section mt-3">
                        {item.comments.map((comment, commentIndex) => (
                          <div key={commentIndex} className="comment-item mb-2">
                            <div className="d-flex align-items-center gap-2">
                              <img
                                src={comment.userId.profileImage}
                                alt="Profile"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                              <h6 className="ms-2 mb-0">
                                {comment?.userId?.name}
                              </h6>
                            </div>
                            <p className="ms-4 mt-1">{comment.content}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      <div className="add-comment">
        {/* <h2>أضف تقييم</h2> */}

        {/* {token ? (
          <form className="d-flex flex-column" onSubmit={handleSubmit}>
            <label>محتوى التقييم</label>
            <textarea
              name="content"
              value={commentContent}
              required
              onChange={(e) => {
                setCommentContent(e.target.value);
              }}
              placeholder="محتوى التقييم"
              rows="9"
            ></textarea> */}
        {/* {Error&& <p className="text-danger">{Error}</p>} */}
        {/* {message&& <p className="text-success">{message}</p>} */}
        {/* <input type="submit" value="أضف التقييم" className="submit" />
          </form> */}
        {/* ) : (
          <form className="d-flex flex-column">
            <label>محتوى التقييم</label>
            <textarea
              name="content"
              required
              placeholder="محتوى التقييم"
              rows="9"
            ></textarea>
            <div>
              <input type="submit" value="أضف التقييم" className="submit" />
            </div>
          </form>
        )} */}
      </div>
      {/* <AddComment id={product?.product?._id} getProduct={getProduct} /> */}
    </section>
  );
}
export default Rates;
